/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./changeShopping.vue?vue&type=template&id=08166bf0&scoped=true&"
import script from "./changeShopping.vue?vue&type=script&lang=js&"
export * from "./changeShopping.vue?vue&type=script&lang=js&"
import style0 from "./changeShopping.vue?vue&type=style&index=0&id=08166bf0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08166bf0",
  null
  
)

export default component.exports